import {
  CorporateFareIcon,
  QuickReferenceAllIcon,
  ReceiptLongIcon,
  SellIcon,
  ListAltCheckIcon,
  InfoIcon,
  FeatureSearchIcon,
  NoContactRequestIcon,
  ChatIcon,
  AccountCircleIcon,
  NoEventIcon,
  NoBlogIcon,
  NoEventProfileIcon
} from 'assets'
import CustomButton from 'components/atoms/custom-button'
import { useNavigate } from 'react-router-dom'
import { MdCardMembership } from 'react-icons/md'
import { PiLockBold } from 'react-icons/pi'
import { navigateToSSRPage } from 'utils/navigateLandingSSR'

const SSR_PAGE_PATHS = ['/opportunities?tab=seller','/opportunities?tab=buyer', '/webinar', '/connect-days', '/seller-plan', '/buyer-plan', '/join-tomazz', '/pricing']

function EmptyList({ category, isAdvisor, extraInfo = '', onClickEdit, isAdvPkgExist = false, isDisable = false }) {
  const navigate = useNavigate()
  const handleClickButton = () => {
    if (isAdvisor) return navigate(wordingCategoryByFeatures[category]?.pathAdvisor)
    if (category == 'subscription-advisor' && isAdvPkgExist) {
      return navigate('/profile/membership')
    }
    const path = wordingCategoryByFeatures[category]?.path
    if (SSR_PAGE_PATHS.includes(path)) {
      return navigateToSSRPage(path)
    }
    navigate(path)
  }
  const IconComponent = wordingCategoryByFeatures[category]?.icon
  return (
    <div className="py-12 bg-surface-primary-2 flex flex-col items-center space-y-6">
      <div className="w-16 h-16 flex justify-center items-center bg-brand-1 rounded-full">
        <IconComponent className={'fill-brand-default h-10 w-10'} />
      </div>
      <div className="text-center space-y-4">
        <p className="text-xl font-medium">{wordingCategoryByFeatures[category]?.label}</p>
        <p className="text-base text-secondary">{wordingCategoryByFeatures[category]?.desc}</p>
        {
          //for event menu
          wordingCategoryByFeatures[category]?.secondDesc && (
            <p className="text-base text-secondary">
              {wordingCategoryByFeatures[category]?.secondDesc}
            </p>
          )
        }
      </div>
      {extraInfo && (
        <div onClick={onClickEdit} className="flex flex-row gap-2 border-none bg-surface-primary-2">
          <div>
            <InfoIcon />
          </div>
          <label className="text-sm text-info font-medium">{extraInfo}</label>
        </div>
      )}
      {wordingCategoryByFeatures[category]?.buttonLabel && (
        <CustomButton disabled={isDisable} onClick={handleClickButton}>
          {wordingCategoryByFeatures[category]?.buttonLabel}
        </CustomButton>
      )}
    </div>
  )
}

export default EmptyList

const wordingCategoryByFeatures = {
  buyer: {
    icon: SellIcon,
    label: 'Belum Ada Perusahaan Dijual',
    desc: 'Belum perusahaan yang diposting oleh Penjual'
  },
  seller: {
    icon: QuickReferenceAllIcon,
    label: 'Belum Ada Perusahaan Dicari',
    desc: 'Belum ada perusahaan yang diposting oleh Pembeli'
  },
  'advisor-empty': {
    icon: AccountCircleIcon,
    label: 'Belum Ada Advisor',
    desc: 'Belum ada data yang di posting advisor'
  },
  'profile-not-found': {
    icon: AccountCircleIcon,
    label: 'Data profil tidak ditemukan',
    desc: ''
  },
  advisor: {
    icon: ListAltCheckIcon,
    label: 'Profil Anda sedang diverifikasi',
    desc: 'Profil Anda sedang diverifikasi oleh Tim TOMAZZ. Proses ini mungkin memakan waktu hingga 2 hari kerja. Anda akan menerima pemberitahuan ketika verifikasi selesai.'
  },
  knowledgeBase: {
    icon: QuickReferenceAllIcon,
    label: 'Pusat Pengetahuan Akan Segera Hadir',
    desc: 'Belum ada pusat pengetahuan yang diposting oleh Admin'
  },
  emptyEvent: {
    icon: NoEventIcon,
    label: 'Event Akan Segera Hadir',
    desc: 'Kami sedang mempersiapkan sesi event terbaru.',
    secondDesc: 'Nantikan insight dan diskusi menarik dari para ahli.'
  },
  emptyProfileEvent: {
    icon: NoEventProfileIcon,
    label: 'Belum Ada Acara yang Terdaftar',
    desc: 'Telusuri halaman acara dan ikuti sesi yang menarik bagi Anda.',
    buttonLabel: 'Lihat Acara Terbaru',
    path: '/connect-days'
  },
  emptyProfileWebinar: {
    icon: NoEventProfileIcon,
    label: 'Belum Ada Webinar yang Terdaftar',
    desc: 'Telusuri halaman webinar dan ikuti sesi yang menarik bagi Anda.',
    buttonLabel: 'Lihat Webinar Terbaru',
    path: '/webinar'
  },
  emptyBlog: {
    icon: NoBlogIcon,
    label: 'Belum ada artikel yang tersedia',
    desc: 'Saat ini kami sedang mengkurasi wawasan berharga, perspektif ahli, dan informasi terbaru untuk mendukung perjalanan Anda dalam membeli, menjual, dan mengembangkan bisnis.'
  },
  emptyContactReceive: {
    icon: NoContactRequestIcon,
    label: 'Tidak Ada Permintaan Kontak yang Diterima',
    desc: 'Pembeli atau penjual yang meminta untuk menghubungi Anda akan muncul di sini. Anda akan mendapatkan notifikasi ketika ada yang ingin terhubung.'
  },
  emptyContactSent: {
    icon: NoContactRequestIcon,
    label: 'Tidak Ada Permintaan Kontak Terkirim',
    desc: 'Anda belum meminta untuk menghubungi siapa pun. Temukan perusahaan atau pembeli yang sesuai dengan kriteria Anda untuk memulai percakapan.'
  },
  emptyChat: {
    icon: ChatIcon,
    label: 'Belum ada pesan',
    desc: 'Mulai percakapan dengan pembeli, penjual, atau advisor untuk memulai obrolan.'
  },
  unregisteredChat: {
    icon: ChatIcon,
    label: 'Belum Ada Pesan',
    desc: 'Untuk menggunakan fitur pesan, silahkan melakukan permintaan menghubungi dengan pengguna lain.'
  },
  franchise: {
    icon: SellIcon,
    label: 'Belum Ada Perusahaan Dijual',
    desc: 'Belum perusahaan yang diposting oleh Penjual'
  },
  investor: {
    icon: SellIcon,
    label: 'Belum Ada Perusahaan Dijual',
    desc: 'Belum perusahaan yang diposting oleh Penjual'
  },
  transaction: {
    icon: ReceiptLongIcon,
    label: 'Belum Ada Transaksi',
    desc: 'Pembayaran transaksi Anda akan muncul di sini'
  },
  'advisor-no-profile': {
    icon: AccountCircleIcon,
    label: 'Profil Tidak Tersedia',
    desc: 'Buat dan tampilkan profil Anda kepada penjual dan pembeli. Tingkatkan visibilitas dan soroti profesional Anda!',
    buttonLabel: 'Buat Profil',
    path: '/advisor/listings/advisor-profile', //dummy
    pathAdvisor: '/advisor/listings/advisor-profile' // still unknown where to navigate for membership
  },
  'favorite-company-for-sale': {
    icon: CorporateFareIcon,
    label: 'Tidak Ada Profil Favorit',
    desc: 'Simpan profil perusahaan yang menarik bagi Anda dan mudah untuk mengunjunginya kembali nanti',
    buttonLabel: 'Lihat Perusahaan Dijual',
    path: '/buyer'
  },
  'favorite-wanted-company': {
    icon: CorporateFareIcon,
    label: 'Tidak Ada Profil Favorit',
    desc: 'Simpan profil pembeli yang cocok dengan bisnis Anda dan mudah untuk terhubung kembali nanti',
    buttonLabel: 'Lihat Perusahaan yang Dicari',
    path: '/seller'
  },
  'profile-wanted-company': {
    icon: QuickReferenceAllIcon,
    label: 'Belum Ada Profil Pembeli',
    desc: 'Beritahu penjual bisnis yang Anda cari dan temukan peluang yang tepat!',
    buttonLabel: 'Buat Profil Pembeli',
    path: '/buyer/listing/buy-company',
    pathAdvisor: '/advisor/listing/buy-company'
  },
  'company-for-sale': {
    icon: SellIcon,
    label: 'Belum Ada Perusahaan Dijual',
    desc: 'Tambahkan bisnis Anda sekarang dan jangkau calon pembeli yang tepat!',
    buttonLabel: 'Jual Perusahaan Sekarang',
    path: '/seller/listing/sell-company',
    pathAdvisor: '/advisor/listing/sell-company'
  },
  'membership-seller': {
    icon: MdCardMembership,
    label: 'Belum Ada Keanggotaan Penjual',
    desc: 'Tingkatkan visibilitas bisnis Anda, jangkau calon pembeli yang serius, dan jual perusahaan dengan lebih mudah',
    buttonLabel: 'Beli Paket Penjual',
    // TODO: DELETED SOON
    // path: '/seller/buy-package'
    path: '/seller-plan'
  },
  'membership-buyer': {
    icon: MdCardMembership,
    label: 'Belum Ada Keanggotaan Pembeli',
    desc: 'Dapatkan akses eksklusif ke daftar bisnis yang dijual, simpan pencarian favorit, dan hubungi penjual langsung',
    buttonLabel: 'Beli Paket Pembeli',
    // TODO: DELETED SOON
    // path: '/buyer/buy-package'
    path: '/buyer-plan'
  },
  'membership-advisor': {
    icon: MdCardMembership,
    label: 'Belum Ada Keanggotaan Advisor',
    desc: 'Tingkatkan visibilitas bisnis Anda, jangkau calon pembeli yang serius, dan jual perusahaan dengan lebih mudah',
    buttonLabel: 'Beli Paket Pembeli',
    path: '',
    pathAdvisor: '' // still unknown where to navigate for membership
  },
  'search-agent-buyer': {
    icon: FeatureSearchIcon,
    label: 'Belum Ada Pencarian',
    desc: 'Simpan kriteria pencarian Anda untuk perusahaan yang diinginkan',
    buttonLabel: 'Telusuri profil pembeli yang diinginkan',
    path: '/opportunities?tab=seller',
    pathAdvisor: '' // still unknown where to navigate for membership
  },
  'search-agent-seller': {
    icon: FeatureSearchIcon,
    label: 'Belum Ada Pencarian',
    desc: 'Simpan kriteria pencarian Anda untuk perusahaan yang diinginkan',
    buttonLabel: 'Telusuri profil penjual yang diinginkan',
    path: '/opportunities?tab=buyer',
    pathAdvisor: '' // still unknown where to navigate for membership
  },
  'feature-message-locked': {
    icon: PiLockBold,
    label: 'Fitur Pesan Terkunci',
    desc: 'Kamu memerlukan langganan untuk menggunakan fitur pesan.',
    buttonLabel: 'Berlangganan sekarang',
    path: '/pricing'
  },
  'feature-message-locked-profile': {
    icon: PiLockBold,
    label: 'Fitur Pesan Terkunci',
    desc: 'Buat dan lengkapi profil Anda di Menu Akun untuk dapat menggunakan fitur chat.',
    buttonLabel: 'Lengkapi Sekarang',
    path: '/profile/company-for-sale'
  },
  'feature-message-locked-profile-advisor': {
    icon: PiLockBold,
    label: 'Fitur Pesan Terkunci',
    desc: 'Buat dan lengkapi profil Anda di Menu Akun untuk dapat menggunakan fitur chat.',
    buttonLabel: 'Lengkapi Sekarang',
    path: '/profile/advisor-information'
  },
  'subscription-company-for-sale': {
    icon: ReceiptLongIcon,
    label: 'Tidak Ada Paket Penjual',
    desc: 'Kamu tidak memiliki paket yang tersedia',
    buttonLabel: 'Beli Paket',
    // TODO: DELETED SOON
    // path: '/seller/buy-package'
    path: '/seller-plan'
  },
  'subscription-wanted-company': {
    icon: ReceiptLongIcon,
    label: 'Tidak Ada Paket Pembeli',
    desc: 'Kamu tidak memiliki paket yang tersedia',
    buttonLabel: 'Beli Paket',
    // TODO: DELETED SOON
    // path: '/buyer/buy-package'
    path: '/buyer-plan'
  },
  'subscription-advisor': {
    icon: ReceiptLongIcon,
    label: 'Tidak Ada Paket Advisor',
    desc: 'Kamu tidak memiliki paket yang tersedia',
    buttonLabel: 'Beli Paket',
    // TODO: DELETED SOON
    // path: '/advisor/buy-package'
    path: '/join-tomazz'
  }
}
